import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustrationNoProfiles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 209,
	height: 200,
	viewBox: "0 0 209 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
			fill: "#EEF755"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_31_1815)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M145 58H81C77.6863 58 75 60.6863 75 64V139C75 142.314 77.6863 145 81 145H145C148.314 145 151 142.314 151 139V64C151 60.6863 148.314 58 145 58Z",
				fill: "#C8D5FF"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_31_1815)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M137 50H61C57.6863 50 55 52.6863 55 56V149C55 152.314 57.6863 155 61 155H137C140.314 155 143 152.314 143 149V56C143 52.6863 140.314 50 137 50Z",
				fill: "#C8D5FF"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_d_31_1815)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M128.003 42.999H51.003C47.6893 42.999 45.003 45.6853 45.003 48.999V156.999C45.003 160.313 47.6893 162.999 51.003 162.999H128.003C131.317 162.999 134.003 160.313 134.003 156.999V48.999C134.003 45.6853 131.317 42.999 128.003 42.999Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .102,
			d: "M118 133H61C59.8954 133 59 133.895 59 135V137C59 138.105 59.8954 139 61 139H118C119.105 139 120 138.105 120 137V135C120 133.895 119.105 133 118 133Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .102,
			d: "M107 142H73C71.8954 142 71 142.895 71 144V145C71 146.105 71.8954 147 73 147H107C108.105 147 109 146.105 109 145V144C109 142.895 108.105 142 107 142Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 56.001H70C65.0294 56.001 61 60.0304 61 65.001C61 69.9715 65.0294 74.001 70 74.001H108C112.971 74.001 117 69.9715 117 65.001C117 60.0304 112.971 56.001 108 56.001Z",
			fill: "#F6FBA9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 101C108 90.5066 99.4934 82 89 82C78.5066 82 70 90.5066 70 101C70 111.493 78.5066 120 89 120C99.4934 120 108 111.493 108 101Z",
			fill: "#4B75FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.8906 90.5C92.1719 90.5 95.7266 93.1172 95.7266 96.5156C95.7266 101.047 90.8438 101.125 90.8438 102.805V103C90.8438 103.547 90.4141 103.937 89.9062 103.937H87.0547C86.5469 103.937 86.1172 103.547 86.1172 103V102.648C86.1172 100.227 87.9531 99.25 89.3594 98.4687C90.5312 97.8047 91.2734 97.375 91.2734 96.4765C91.2734 95.3047 89.7891 94.5625 88.5781 94.5625C87.0547 94.5625 86.3125 95.2656 85.3359 96.4765C85.0234 96.8672 84.4375 96.9453 84.0469 96.6328L82.3672 95.3437C81.9375 95.0703 81.8594 94.4843 82.1328 94.0937C83.7344 91.789 85.7656 90.5 88.8906 90.5ZM88.5 105.109C89.9844 105.109 91.1953 106.32 91.1953 107.805C91.1953 109.289 89.9844 110.5 88.5 110.5C86.9766 110.5 85.7656 109.289 85.7656 107.805C85.7656 106.32 86.9766 105.109 88.5 105.109Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_d_31_1815)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M200 30C200 18.9543 191.046 10 180 10C168.954 10 160 18.9543 160 30C160 41.0457 168.954 50 180 50C191.046 50 200 41.0457 200 30Z",
				fill: "#FF7181"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.578 29.5L186.484 33.4453C186.992 33.9141 186.992 34.6953 186.484 35.1641L185.625 36.0234C185.156 36.5312 184.375 36.5312 183.906 36.0234L180 32.1172L176.055 36.0234C175.586 36.5312 174.805 36.5312 174.336 36.0234L173.477 35.1641C172.969 34.6953 172.969 33.9141 173.477 33.4453L177.383 29.5L173.477 25.5938C172.969 25.125 172.969 24.3438 173.477 23.875L174.336 23.0156C174.805 22.5078 175.586 22.5078 176.055 23.0156L180 26.9219L183.906 23.0156C184.375 22.5078 185.156 22.5078 185.625 23.0156L186.484 23.875C186.992 24.3438 186.992 25.125 186.484 25.5938L182.578 29.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_31_1815",
				x: 63,
				y: 52,
				width: 100,
				height: 111,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1815"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1815",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_31_1815",
				x: 43,
				y: 44,
				width: 112,
				height: 129,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1815"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1815",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_31_1815",
				x: 35.003,
				y: 42.999,
				width: 109,
				height: 140,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 10 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1815"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1815",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_d_31_1815",
				x: 154,
				y: 7,
				width: 52,
				height: 52,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0509804 0 0 0 0 0.160784 0 0 0 0 0.462745 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1815"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1815",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgIllustrationNoProfiles;
